<template>
  <div>
    <el-dialog v-model="verifyShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">提示</div>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20"><CloseBold /></el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="content">
          <div>为了保证你的账号安全，请验证身份，验证成功后才能 修改</div>
          <div class="phone_input">使用手机{{ $Tools.phoneHide(phone) }}验证</div>
          <slider class="mar_top_15" @getCode="getCode"></slider>
          <div class="flex FlexBetween code_box mar_top_15">
            <el-input v-model="verificationCode" @input="(e) => checkNumber(e)" style="max-width: 600px; height: 44px; border-radius: 10px"
            placeholder="请输入验证码"></el-input>
            <div class="btn_getCode cursor_pointer mar_left_20" @click="getCode">{{ textCode }}</div>
          </div>
          <div class="error_msg flex Flexalign mar_top_10" v-show="errorCode">
            <el-image class="error_icon" :src="iconPath('error_icon.png')"></el-image>
            <div class="error_text mar_left_10">验证码错误</div>
          </div>
          <div class="code_attention" v-show="disabled">验证码已发送至你的手机</div>
          <div class="btn_verify cursor_pointer" @click="verifyPhone">验证</div>
        </div>
      </div>
    </el-dialog>
    <changePhone ref="changePhone"></changePhone>
  </div>
</template>

<script>
import slider from "@/components/slider/index";
import changePhone from './changePhone.vue';
export default {
  name: "GjkcH5Verify",
  components: {
    slider,
    changePhone
  },

  data() {
    return {
      verifyShow: false,
      textCode: "获取验证码",
      disabled: false,
      phone: "",
      errorCode: false,
      verificationCode:'', // 验证码
    };
  },

  mounted() {},

  methods: {
    closePopup() {
      this.verifyShow = false;
    },
    checkNumber(value) {
      this.verificationCode = value.replace(/[^0-9]/g, ""); // 移除非数字字符
    },
    getCode() {
      if (this.disabled) return;
      this.getPhoneCode();
      this.disabled = true;
      let n = 60;
      this.textCode = "重新发送 " + n + "s";
      const run = setInterval(() => {
        n = n - 1;
        if (n < 0) {
          clearInterval(run);
        }
        this.textCode = "重新发送 " + n + "s";
        if (this.textCode < "重新发送 " + 0 + "s") {
          this.disabled = false;
          this.textCode = "重新获取";
        }
      }, 1000);
    },
    // 获取验证码
    getPhoneCode() {
      if (this.$Tools.empty(this.phone)) {
        this.$Dialog.toast("手机号不能为空", { type: "error" });
        return;
      }
      if (!/^1[345678]\d{9}$/.test(this.phone)) {
        this.$Dialog.toast("请输入正确的手机号", { type: "error" });
        return;
      }
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.textCode = "重新发送 " + n + "s";
      this.$Api.login.getCode({ phone: this.phone }).then((res) => {
        if (res.data.code == 200) {
          this.$Dialog.toast("验证码已发送");
          const run = setInterval(() => {
            n = n - 1;
            if (n < 0) {
              clearInterval(run);
            }
            this.textCode = "重新发送 " + n + "s";
            if (this.textCode < "重新发送 " + 0 + "s") {
              this.disabled = false;
              this.textCode = "重新获取";
            }
          }, 1000);
        }
      });
    },
    verifyPhone(){
      this.$Api.user.checkPhone({phone:this.phone,verificationCode:this.verificationCode}).then(res=>{
        console.log(res)
        this.errorCode = false;
        this.closePopup();
        this.$refs.changePhone.changePhoneShow = true;
      }).catch(()=>{
        this.errorCode = true;
      })
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 486px;
  height: 480px;
  position: relative;
}
:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}
.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}
.dialog_content {
  .content {
    width: 100%;
    // height: 450px;
    // overflow: auto;
    font-size: 18px;
    color: #8e8e8e;
    padding: 20px;
    box-sizing: border-box;
    line-height: 36px;
    .phone_input {
      width: 100%;
      height: 46px;
      border-radius: 5px;
      border: 1px solid #d8d8d8;
      padding: 0 12px;
      line-height: 46px;
      box-sizing: border-box;
      color: #2d2d2d;
      font-size: 16px;
    }
    .code_box {
      width: 100%;
      height: 46px;
      .code_input {
        width: 307px;
      }
      .btn_getCode {
        min-width: 150px;
        height: 44px;
        background: #edeced;
        border-radius: 5px;
        border: 1px solid #d8d8d8;
        color: #2d2d2d;
        text-align: center;
        line-height: 44px;
        font-size: 16px;
        padding: 0 15px;
        box-sizing: border-box;
      }
    }
    .error_msg {
      .error_icon {
        width: 17px;
        height: 17px;
      }
      .error_text {
        font-size: 14px;
        color: #cb3f35;
      }
    }
    .code_attention {
      font-size: 14px;
      color: #999999;
    }
    .btn_verify {
      width: 124px;
      height: 36px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 18px;
      font-size: 18px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      margin: 20px auto;
    }
  }
}
</style>
